import { render } from "./LinkDetail.vue?vue&type=template&id=f01325c0&scoped=true"
import script from "./LinkDetail.vue?vue&type=script&lang=js"
export * from "./LinkDetail.vue?vue&type=script&lang=js"

import "./LinkDetail.vue?vue&type=style&index=0&id=f01325c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f01325c0"]])

export default __exports__